/**
 * Allows food to be stacked into combined food items.
 */
export function Stackable(base) {
    return class extends base {
        stack(obj) {
            return null;
        }
    };
}
export function isStackable(obj) {
    return 'stack' in obj;
}
